export default {
    nl: {
        intro: {
            subtitle: 'Automated testing',
            title: 'Automatisch testen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/automated-testing/hero.webp',
        },
        type: 'Automated testing',
        title: 'Automated testing: Efficiënt testen en snel resultaat',
        description:
            'Verhoog softwarekwaliteit met geautomatiseerde tests. Bespaar tijd en ontdek de problemen met oplossingen voor je digitale producten.',
        content: [
            {
                type: 'text',
                title: 'Automated testing',
                content:
                    'Automated Testing, oftewel testautomatisering, wordt binnen 23G gebruikt als de basis van onze geavanceerde software testprocessen. Met deze aanpak automatiseren we het uitvoeren van testcases en controleren we software functionaliteit met behulp van specifieke tools en scripts. Het draagt bij aan het verhogen van de efficiëntie, nauwkeurigheid en snelheid van ons testwerk.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/laptops-meeting.webp',
                ],
            },
            {
                type: 'text',
                title: 'Automated testing',
                content:
                    'Weg met urenlang handmatig testen! Waar traditionele testcases handmatig werden uitgevoerd, stelt testautomatisering onze testers in staat om geautomatiseerde scripts te schrijven. Afhankelijk van de klus kiezen we de juiste taal en tools. Wij zijn fan van technologieën als Laravel, PHP en platformen als AWS.',
            },
            {
                type: 'text',
                title: 'De voordelen van automated testing',
                content:
                    'De inzet van automated testing biedt ons team talloze voordelen. Om te beginnen zorgt het voor een verhoogde efficiëntie; testen gaat snel en bespaart iedereen tijd. Daarnaast leveren de geautomatiseerde tests keer op keer consistente en betrouwbare resultaten op.',
            },
            {
                type: 'quote',
                content:
                    'Automated testing is perfect voor terugkerende klussen, zoals regressietests.',
            },
            {
                type: 'text',
                title: 'Snelheid en precisie',
                content:
                    'Bij 23G kijken we altijd naar hoe we zaken kunnen stroomlijnen. Zo levert automated testing snel feedback op waar ontwikkelaars snel mee aan de slag kunnen. Bovendien haalt het de menselijke missers eruit en verhoogt de nauwkeurigheid. Hiermee bespaar je op termijn flink mee!',
            },
            {
                type: 'text',
                title: 'Wanneer kiezen voor automated testing?',
                content: `
                    Automated testing is perfect voor terugkerende klussen, zoals regressietests. Het is echter niet ideaal voor iedere test scenario. Bij testen waar menselijke creativiteit en intuïtie een grotere rol spelen, zoals exploratory testing, kijkt er altijd nog een professioneel oog mee.
                    <br><br>
                    Wat deze testmethode ons brengt? Software van topkwaliteit. Sneller problemen ontdekken en ze gladstrijken. Hierdoor leveren we digitale producten die je van ons mag verwachten.
                `,
            },
            {
                type: 'case',
                case: 'cbre',
            },
        ],
        related_services: ['client-portal', 'front-end-development', 'api'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
